import { FileText } from "lucide-react";
import SourceDocumentCard from "./SourceDocumentCard";
import type { SourceDocument } from "@/components/types";

interface SourceDocumentListProps {
  filteredSourceDocuments: SourceDocument[];
  selectedDocType: string;
  nudgedDocumentId: string | null;
}

const SourceDocumentList = ({ 
  filteredSourceDocuments, 
  selectedDocType, 
  nudgedDocumentId 
}: SourceDocumentListProps) => {
  return (
    <div className="p-4 max-md:p-3 space-y-4" dir="rtl">
      {filteredSourceDocuments && Array.isArray(filteredSourceDocuments) && filteredSourceDocuments.length > 0 ? (
        filteredSourceDocuments.map((doc) => (
          <SourceDocumentCard 
            key={doc._id} 
            sourceDocumentData={doc} 
            isNudged={nudgedDocumentId === doc._id} 
          />
        ))
      ) : (
        <div className="text-center py-12">
          <div className="space-y-4">
            <div className="w-16 h-16 mx-auto bg-slate-100 rounded-full flex items-center justify-center">
              <FileText className="w-8 h-8 text-slate-400" />
            </div>
            <div>
              <h3 className="text-lg font-medium text-slate-700 mb-2">
                {selectedDocType === "סימוכין" ? "אין מסמכים שמוזכרים בתשובה" : "אין מסמכים זמינים"}
              </h3>
              <p className="text-sm text-slate-500">
                {selectedDocType === "סימוכין" ? "התשובה לא מתייחסת למסמכים ספציפיים" : "אין מסמכים זמינים בקטגוריה זו"}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SourceDocumentList;
